import dayjs from 'dayjs'

export const formatAuditTimestamp = (timestamp) => {
  if (!timestamp) return '-'
  return dayjs(timestamp).format('M/DD/YY HH:mm') + ' hrs'
}

export const formatEventType = (eventType) => {
  if (!eventType) return '-'
  const eventMap = {
    UPDATE: 'Updated',
    CREATE: 'Created',
    INSERT: 'Created',
    DELETE: 'Deleted'
  }
  return eventMap[eventType.toUpperCase()] || eventType
}

export const formatUserRoles = (userRoles) => {
  if (!userRoles || userRoles.length === 0) return '-'
  return userRoles.join(', ')
}

export const formatChangedDataValues = (property, changedData) => {
  if (!changedData || changedData.length === 0) {
    return '-'
  }

  if (property?.toLowerCase() === 'permission') {
    return 'View Permission'
  }

  const values = changedData.filter((item) => typeof item === 'string' && item.trim() !== '')
  return values.length > 0 ? values.join(', ') : '-'
}

export const PROJECT_AUDIT_COLUMNS = [
  {id: 'clientId', label: 'Client ID', minWidth: 100},
  {
    id: 'clientName',
    label: 'Client Name',
    minWidth: 140,
    truncatedContentInfo: 'Hover over the short names to view full content'
  },
  {id: 'event', label: 'Event', minWidth: 120},
  {id: 'projectId', label: 'Project ID', minWidth: 100},
  {
    id: 'projectName',
    label: 'Project Name',
    minWidth: 150,
    truncatedContentInfo: 'Hover over the short names to view full content'
  },
  {id: 'property', label: 'Property', minWidth: 140},
  {
    id: 'values',
    label: 'Values',
    minWidth: 150,
    truncatedContentInfo: 'Hover over the short descriptions to view full content'
  },
  {id: 'timestamp', label: 'Timestamp', minWidth: 160},
  {id: 'modifierEmail', label: 'Modifier Email', minWidth: 180},
  {id: 'modifierRole', label: 'Modifier Role', minWidth: 140}
]

export const transformAuditProjectToRow = (project, index) => {
  return {
    id: index + 1,
    clientId: project.CLIENT_ID || '-',
    clientName: project.CLIENT_NAME || '-',
    event: formatEventType(project.EVENT_TYPE),
    projectId: project.GROUP_ID || '-',
    projectName: project.GROUP_NAME || '-',
    property: project.PROPERTY || '-',
    values: formatChangedDataValues(project.PROPERTY, project.CHANGED_DATA),
    timestamp: formatAuditTimestamp(project.AUDITED_AT),
    modifierEmail: project.CHANGED_BY || '-',
    modifierRole: formatUserRoles(project.USER_ROLE),
    changedData: project.CHANGED_DATA || [],
    snapshot: project.SNAPSHOT || null
  }
}

export const transformAuditDataToTableFormat = (auditData) => {
  if (!auditData?.getAuditDetails?.projects) {
    return {
      columns: PROJECT_AUDIT_COLUMNS,
      rows: [],
      pagination: {page: 1, pageSize: 5, totalCount: 0}
    }
  }

  const {projects, page, pageSize, totalCount} = auditData.getAuditDetails
  const rows = projects.map((project, index) => transformAuditProjectToRow(project, index))

  return {
    columns: PROJECT_AUDIT_COLUMNS,
    rows,
    pagination: {page, pageSize, totalCount}
  }
}

export default transformAuditDataToTableFormat
